var _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLinkIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58056 5.34833C3.87346 5.64122 3.87346 6.1161 3.58056 6.40899L2.87346 7.1161C1.21373 8.77583 1.21373 11.4668 2.87346 13.1265C4.53319 14.7862 7.22414 14.7862 8.88386 13.1265L9.59097 12.4194C9.88386 12.1265 10.3587 12.1265 10.6516 12.4194C10.9445 12.7123 10.9445 13.1872 10.6516 13.4801L9.94452 14.1872C7.69901 16.4327 4.05831 16.4327 1.8128 14.1872C-0.432716 11.9417 -0.432717 8.30095 1.8128 6.05544L2.5199 5.34833C2.8128 5.05544 3.28767 5.05544 3.58056 5.34833Z",
    fill: "#009DD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4194 10.6516C12.1265 10.3587 12.1265 9.88387 12.4194 9.59097L13.1265 8.88387C14.7862 7.22414 14.7862 4.53319 13.1265 2.87346C11.4668 1.21373 8.77583 1.21373 7.1161 2.87346L6.40899 3.58056C6.1161 3.87346 5.64123 3.87346 5.34833 3.58056C5.05544 3.28767 5.05544 2.8128 5.34833 2.5199L6.05544 1.8128C8.30095 -0.432718 11.9417 -0.432716 14.1872 1.8128C16.4327 4.05831 16.4327 7.69901 14.1872 9.94453L13.4801 10.6516C13.1872 10.9445 12.7123 10.9445 12.4194 10.6516Z",
    fill: "#009DD7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3587 4.64122C11.6516 4.93412 11.6516 5.40899 11.3587 5.70189L5.70189 11.3587C5.40899 11.6516 4.93412 11.6516 4.64123 11.3587C4.34833 11.0658 4.34833 10.591 4.64123 10.2981L10.2981 4.64122C10.591 4.34833 11.0658 4.34833 11.3587 4.64122Z",
    fill: "#009DD7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/link-icon.114d7b59.svg";
export { ForwardRef as ReactComponent };